export { default as ProfessorsSectionItem } from './ProfessorsSection';
